import { useEffect } from "react";
import { RouterProvider } from "react-router";
import { router } from "./routes";
import { AppProvider } from "./context/AppContext";
import { supabase } from "../services/supabase";
import * as Sentry from "@sentry/react";

// Ping ringan untuk membangunkan Supabase free-tier cold start.
// Cukup satu ping dengan delay kecil — VPS cron sudah menjaga Supabase
// tetap warm setiap 10 menit selama jam kerja (08-18 WITA hari kerja).
function usePingSupabase() {
  useEffect(() => {
    const t = setTimeout(() => {
      supabase.from("visitors").select("id").limit(1);
    }, 500);
    return () => clearTimeout(t);
  }, []);
}

function AppInner() {
  usePingSupabase();
  return <RouterProvider router={router} />;
}

function ErrorFallback() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-6 text-center">
      <div className="text-6xl mb-4">😵</div>
      <h1 className="text-xl mb-2" style={{fontWeight:700, color:"#003580"}}>Ups, sistem sedang istirahat!</h1>
      <p className="text-sm text-gray-500 mb-6 max-w-xs">Terjadi kesalahan yang tidak terduga. Tim kami sudah mendapat laporan otomatis.</p>
      <button
        onClick={() => window.location.reload()}
        className="px-6 py-2.5 bg-[#003580] text-white rounded-xl text-sm hover:bg-[#0057b7] transition-colors"
        style={{fontWeight:600}}
      >
        Muat Ulang Halaman
      </button>
    </div>
  );
}

export default function App() {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <AppProvider>
        <AppInner />
      </AppProvider>
    </Sentry.ErrorBoundary>
  );
}
